module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mt-4",
    attrs: {
      "id": "billing-pref"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "mt-4 pt-2"
  }, [_vm._v("Billing Preference")]), _vm._v(" "), _c('label', {
    staticClass: "radio-head"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "billing-pref"
    },
    domProps: {
      "checked": _vm.form_data.auto_pay
    },
    on: {
      "input": function($event) {
        return _vm.setAutoPay(true)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Auto-bill monthly")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-head"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "billing-pref"
    },
    domProps: {
      "checked": !_vm.form_data.auto_pay
    },
    on: {
      "input": function($event) {
        return _vm.setAutoPay(false)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Manual payment")])])]), _vm._v(" "), (_vm.showBillingAddress) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "mt-4 pt-2"
  }, [_vm._v("Billing Address")]), _vm._v(" "), _c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "billing-addr-same"
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "billing-addr-same"
    },
    domProps: {
      "checked": _vm.copyAddress
    },
    on: {
      "input": function($event) {
        return _vm.setCopyAddress(true)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.addressString))])]), _vm._v(" "), _c('label', {
    staticClass: "radio-head"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "billing-addr-same",
      "id": "different-billing-addr"
    },
    domProps: {
      "checked": _vm.copyAddress === false
    },
    on: {
      "input": function($event) {
        return _vm.setCopyAddress(false)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Enter new address")])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('revio-address-nptf')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBillingAddress && (_vm.copyAddress !== null) && !_vm.copyAddress),
      expression: "showBillingAddress && (copyAddress !== null) && !copyAddress"
    }],
    attrs: {
      "id": "revio-address-nptf"
    }
  }, [_c('revio-address', {
    attrs: {
      "company": false
    },
    on: {
      "form-state": function (x) { return _vm.address_valid = x; }
    },
    model: {
      value: (_vm.form_data.billing_address),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "billing_address", $$v)
      },
      expression: "form_data.billing_address"
    }
  })], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c795f642","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewPaymentTypeForm.vue
// module id = 1347
// module chunks = 16